const PermissionEnum = {
    Gaau: {
        Adicionar: "Gaau.Adicionar",
        Visualizar: "Gaau.Visualizar",
        Remover: "Gaau.Remover",
        Editar: "Gaau.Editar",
        ImagemRemover: "Gaau.Imagem.Remover",
        AdicionarHistorico: "Gaau.Adicionar.Historico"
    },
    DynamicForm: {
        Adicionar: "DynamicForm.Adicionar",
        Visualizar: "DynamicForm.Visualizar",
        Remover: "DynamicForm.Remover",
        Editar: "DynamicForm.Editar"
    },

};

export default PermissionEnum;
